<template>
    <Container>
        <SectionWrapper>
            <SettingButton
                v-for="(button, index) in settingsButtons"
                :key="`s-${index}`"
                :href="button.to"
                target="_blank">
                {{ button.text }}
            </SettingButton>
        </SectionWrapper>
    </Container>
</template>

<script setup lang="ts">
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();
    const settingsButtons = computed(() => [
        {
            text: t('Legal.termsAndConditions'),
            to: 'https://24horas.pt/',
        },
        {
            text: t('Legal.politics'),
            to: 'https://24horas.pt/',
        },
        {
            text: t('Legal.communication'),
            to: 'https://24horas.pt/',
        },
        {
            text: t('Legal.corruption'),
            to: 'https://24horas.pt/',
        },
        {
            text: t('Legal.prevention'),
            to: 'https://24horas.pt/',
        },
    ]);
</script>

<style scoped></style>
